define('components/ProviderFilter/ProviderFilterComponent',[
	'core/can',
	'models/Session',
	'text!components/ProviderFilter/ProviderFilterView.stache'
], function(can, Session, template) {
	
	can.Component.extend({
		
		tag: 'ax-providers',
		
		template: template,
		
		scope: {
			
			init: function() {
				
				// Must be in init, otherwise Session 
				// will be evaluated but undefined when loaded
				this.attr('Providers', Session.attr('Providers'));
				
				// If ProviderId is already set
				var id = this.attr('map.ProviderId');
				if (id) this.set(id)
			},

			selected: 'All Providers',
						
			singleProvider: can.compute(function() {
				return this.attr('Providers.length') === 1 ? this.attr('Providers.0') : false;
			}),
			
			set: function(id) {
				var selected = ((id === '')
						? 'All Providers'
						: this.attr('Providers').findById(id).attr('Name'));
				
				// Set Selected Provider
				this.attr('selected', selected);
				
				// Update Bound Attribute
				if (this.attr('map')) 
					this.attr('map.ProviderId', id);
			}
		},
		
		events: {
			'.dropdown-menu a click': function(el, ev) {
				this.scope.set(el.data('id'));
			}
		}
	});
	
});
